 
import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Model Development",
      description:
        "We develop customized machine learning models that are designed to solve your specific business challenges using a variety of algorithms and approaches.",
      color: "#7AC943",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Data Preprocessing",
      description:
        "We ensure that your data is properly cleaned, transformed, and prepared for use in building AI models, ensuring better accuracy and performance.",
      color: "#3FA34D",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Model Training & Evaluation",
      description:
        "Our team rigorously trains AI/ML models and evaluates their performance to ensure optimal accuracy, precision, and recall for your use case.",
      color: "#00A7C4",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Model Optimization",
      description:
        "We optimize machine learning models by fine-tuning hyperparameters and applying various techniques to enhance their performance and scalability.",
      color: "#0077B6",
      animation: { x: 0, y: -100 }, // from top
    },
    {
      title: "Real-Time Model Deployment",
      description:
        "We deploy machine learning models into production environments, allowing real-time decision-making and automation for your business operations.",
      color: "#FF9800",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "AI/ML Model Maintenance",
      description:
        "We offer continuous support and maintenance for deployed models, ensuring they stay updated and relevant as your business needs evolve.",
      color: "#9C27B0",
      animation: { x: 100, y: 0 }, // from right
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "28px",
      marginBottom: "30px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: "20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Empowering Your Business with AI/ML</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={feature.animation}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
